export default __webpack_public_path__ + "static/media/react-movie-logo.5c6cd672.svg";